module.exports = __webpack_public_path__ + "static/img/bofangluyin.b109543.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/bofangluyin.png
// module id = em6g
// module chunks = 24